import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Config } from '../../default-config';
import { resetState, registerContact, KontaktMegActionTypes } from '../actions';
import ContactForm from '../components/contactForm';
import { ApplicationState } from '../reducers';

const mapStateToProps = (state: ApplicationState, ownProps: Config) => {
    return {
        registerPending: state.kontaktMeg.registerPending,
        registerSuccess: state.kontaktMeg.registerSuccess,
        hasError: state.kontaktMeg.hasError,
        bankregnrFromSitecore: ownProps.bankregnr,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<KontaktMegActionTypes>) => {
    return bindActionCreators({ resetState, registerContact }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
